// @app/duck/actions.jsx
import { createActions } from 'reduxsauce';

const { Creators, Types } = createActions({
    privacyRequestPrivacyPolicy: [],
    privacyReceivePrivacyPolicy: ["policy"]
});

export { Creators, Types };